<script setup lang="ts">

import config from '@/assets/config';
import { Accordion } from 'primevue';
import { computed, ref } from 'vue';
import ScopeFilteredModel from '../../models/ScopeFilteredModel';

  // const props = defineProps<{
  //   selectionFilter: string | null;
  // }>();

  const emits = defineEmits(['answerChanged']);

  const scope = ref(new ScopeFilteredModel());
  const loading = ref(false);
  const error = ref(null);
  const selScopeFilter = ref('');
  const selQuestionFilter = ref('');

  const notLoading = computed({
    get: () => !loading.value,
    set: (val) => {
      // when the child updates `visible`, invert and write back to `loading`
      loading.value = !val
    }
  })
  
  function clearQuestions() {
    selScopeFilter.value = '';
    scope.value = new ScopeFilteredModel();
    loading.value = false;
    error.value = null;
  }

  // Carregar as questões
  function  loadQuestions(scopeFilter : string, questionFilter : string | null = null) {
      selScopeFilter.value = scopeFilter;
      selQuestionFilter.value = questionFilter;
      console.log("loading questions for " + scopeFilter);
      loading.value = true; // Ativa o spinner antes de qualquer operação

      setTimeout(async () => {
        try {
            var user = localStorage.getItem('user');
            const token = localStorage.getItem('token');
            var url = `${config.backendUrl}api/ControlsEvaluation/questions/${user}`;
            if (questionFilter !== null) {
                if (questionFilter === 'pending-control-points') {
                    url += '?answered=false';
                } else if (questionFilter === 'answered-control-points') {
                    url += '?answered=true';
                }
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            var json : ScopeFilteredModel = await response.json();
            scope.value = json;
        } catch (err) {
            error.value = err.message;
        } finally {
            loading.value = false; // Desativa o spinner após a conclusão
        }
      }, 0); // Garante que o spinner seja exibido antes de iniciar o carregamento
  }

  // EVENT HANDLER: uma questão foi alterada
  function handleAnswerChanged(){
      emits('answerChanged', true);
  }

  // EVENT HANDLER: foi solicitada a submissão das respostas
  function submitAnswers() {
      var filteredQuestions = scope.value.questions.filter(x => x.reportDates.some(y => y.changed));
      if (filteredQuestions.length === 0) {
          console.log('No questions to submit.');
      }
      else {
          var questions = scope.value.questions.filter(x => x.reportDates.some(y => y.changed));
          console.log('Questions sent:' + questions.length);  //TODO: post to the backend
          var answers = filteredQuestions.flatMap(x => x.reportDates).filter(rpt => rpt.changed) 
          console.log('Answers sent:' + answers.length);  //TODO: post to the backend
          
          //send answers to the backend
          const token = localStorage.getItem('token');
          fetch(config.backendUrl + 'api/ControlsEvaluation/answers', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(questions)
          })
          .then(async (response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            console.log("answer saved successfully");
            loadQuestions(selScopeFilter.value, selQuestionFilter.value);
          })
      }
  }

  defineExpose({
      clearQuestions,
      loadQuestions,
      submitAnswers
  });

  // onMounted(() => {
  //   const data = ScopeService.applyFilter();
  //   if (data && data.questions) {
  //     scope.value = data;
  //   } else {
  //     console.error('Invalid data returned from ScopeService.applyFilter()', data);
  //   }
  // });

  function getSelectionFilter(filter : string) {
    return (scope.value.questions || []).filter(x => x.scopeKey.startsWith(filter))
  }

 
</script>

<template>
  <div>
    <Dialog v-model:visible="loading" modal :closable="false">
      <div class="spinner-container">
        <i class="pi pi-spin pi-spinner spinner"></i>
        <p>Carregando questões...</p>
      </div>
    </Dialog>
    <div class="card">
        <Accordion value="0" v-model:visible="notLoading">
          <AccordionPanel v-for="(question, index) in getSelectionFilter(selScopeFilter)" :key="question.id" :value="index" >
              <AccordionHeader>
                <p class="m-5">{{ question.description }}</p>            
              </AccordionHeader>

              <AccordionContent>

                <ReportDatesWidget 
                  :question="question" 
                  :statusList="scope.status"
                  @answerChanged="handleAnswerChanged"/>

                <!-- <DocumentsWidget 
                  :documents="question.documents" /> -->

              </AccordionContent>

          </AccordionPanel>
        </Accordion>
      </div>
  </div>
</template>

<style>
.spinner-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.spinner {
  font-size: 2rem;
  margin-bottom: 1rem;
}
</style>

